import Vue from 'vue'

import Router from 'vue-router';
import Home from '@/containers/Home';
import Politics from '@/components/Politics';
import Cookies from '@/components/Cookies';
import Tycos from '@/components/TyCos';
import sustentable from '@/containers/Sustentable';
import tienditascolormexico from '@/containers/TiendasColor';
import labandaincontenible from '@/containers/ViveLatino';


import VueObserveVisibility from 'vue-observe-visibility'

import VueScrollTo from 'vue-scrollto'

Vue.use(Router)
Vue.use(VueObserveVisibility)
Vue.use(VueScrollTo)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/:id',
      name: 'Routes',
      components: {
        default: Home,
        sustentable: sustentable,
        tienditascolormexico: tienditascolormexico,
        labandaincontenible: labandaincontenible,
        politics: Politics,
        cookies: Cookies,
        tycos: Tycos
      },
/*       props: {
        default: false,
        sustentable: route => ({ query: route.query }),
        tienditascolormexico: route => ({ query: route.query })
      } */
    },
  {
      path: '/',
      name: 'Home',
      component: Home
    },
  ],

})
